export const NewsScope = [
  { text: 'DSJP社員向けニュース', value: 'internal' },
  { text: '得意先向けニュース', value: 'public' }
];